import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { addDraftAttachment, clearDraft, logUnfurlLink, removeDraftAttachment, setDraftMessage } from '../actions/drafts';
export default handleActions({
    [`${setDraftMessage}`]: (state, action)=>{
        var _state_messages_action_payload_room_id;
        var _state_messages_action_payload_room_id_attachments;
        return _object_spread_props(_object_spread({}, state), {
            messages: _object_spread_props(_object_spread({}, state.messages), {
                [action.payload.room_id]: {
                    text: action.payload.text,
                    ts: Date.now(),
                    attachments: (_state_messages_action_payload_room_id_attachments = (_state_messages_action_payload_room_id = state.messages[action.payload.room_id]) === null || _state_messages_action_payload_room_id === void 0 ? void 0 : _state_messages_action_payload_room_id.attachments) !== null && _state_messages_action_payload_room_id_attachments !== void 0 ? _state_messages_action_payload_room_id_attachments : []
                }
            })
        });
    },
    [`${clearDraft}`]: (state, action)=>{
        return _object_spread_props(_object_spread({}, state), {
            messages: _object_spread_props(_object_spread({}, state.messages), {
                [action.payload.room_id]: undefined
            })
        });
    },
    [`${addDraftAttachment}`]: (state, action)=>{
        var _state_messages_action_payload_room_id;
        var _state_messages_action_payload_room_id1, _state_messages_action_payload_room_id_attachments;
        return _object_spread_props(_object_spread({}, state), {
            messages: _object_spread_props(_object_spread({}, state.messages), {
                [action.payload.room_id]: _object_spread_props(_object_spread({}, (_state_messages_action_payload_room_id1 = state.messages[action.payload.room_id]) !== null && _state_messages_action_payload_room_id1 !== void 0 ? _state_messages_action_payload_room_id1 : {}), {
                    attachments: [
                        ...(_state_messages_action_payload_room_id_attachments = (_state_messages_action_payload_room_id = state.messages[action.payload.room_id]) === null || _state_messages_action_payload_room_id === void 0 ? void 0 : _state_messages_action_payload_room_id.attachments) !== null && _state_messages_action_payload_room_id_attachments !== void 0 ? _state_messages_action_payload_room_id_attachments : [],
                        ...[
                            action.payload.attachment
                        ]
                    ]
                })
            })
        });
    },
    [`${removeDraftAttachment}`]: (state, action)=>{
        var _state_messages_action_payload_room_id;
        var _state_messages_action_payload_room_id_attachments;
        const attachments = (_state_messages_action_payload_room_id_attachments = (_state_messages_action_payload_room_id = state.messages[action.payload.room_id]) === null || _state_messages_action_payload_room_id === void 0 ? void 0 : _state_messages_action_payload_room_id.attachments) !== null && _state_messages_action_payload_room_id_attachments !== void 0 ? _state_messages_action_payload_room_id_attachments : [];
        if (attachments.length === 0) {
            return state;
        }
        var _state_messages_action_payload_room_id1;
        return _object_spread_props(_object_spread({}, state), {
            messages: _object_spread_props(_object_spread({}, state.messages), {
                [action.payload.room_id]: _object_spread_props(_object_spread({}, (_state_messages_action_payload_room_id1 = state.messages[action.payload.room_id]) !== null && _state_messages_action_payload_room_id1 !== void 0 ? _state_messages_action_payload_room_id1 : {}), {
                    attachments: [
                        ...attachments.slice(0, action.payload.index),
                        ...attachments.slice(action.payload.index + 1)
                    ]
                })
            })
        });
    },
    [`${logUnfurlLink}`]: (state, action)=>{
        var _state_unfurlLog_action_payload_room_id;
        return _object_spread_props(_object_spread({}, state), {
            unfurlLog: {
                [action.payload.room_id]: [
                    ...(_state_unfurlLog_action_payload_room_id = state.unfurlLog[action.payload.room_id]) !== null && _state_unfurlLog_action_payload_room_id !== void 0 ? _state_unfurlLog_action_payload_room_id : [],
                    ...action.payload.links
                ]
            }
        });
    }
}, {
    messages: {},
    rooms: [],
    unfurlLog: {},
    unfurlResolving: false
});

//# sourceMappingURL=drafts.js.map